import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, take } from 'rxjs';
import { LoadProfilePicture } from 'src/app/store/actions/document.action';
import { DocumentUrlWithKey, profilePictureById } from 'src/app/store/reducer/document.reducer';

@Component({
    standalone: false,
    selector: 'app-employee-avatar',
    templateUrl: './employee-avatar.component.html',
    styleUrls: ['./employee-avatar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmployeeAvatarComponent implements OnInit {
    profilePicture$: Observable<DocumentUrlWithKey>;

    @Input() employeeId: string;
    @Input() initials: string;
    @Input() avatarClasses = 'w-11';

    constructor(private store: Store) {}

    ngOnInit(): void {
        if (this.employeeId) {
            // hack to make component render, before dispatching action (reduces loading time of employee list)
            setTimeout(() => {
                this.store
                    .select(profilePictureById(this.employeeId))
                    .pipe(take(1))
                    .subscribe((profilePicture) => {
                        if (!profilePicture) {
                            this.store.dispatch(LoadProfilePicture({ employeeId: this.employeeId }));
                        }
                    });
            }, 0);

            this.profilePicture$ = this.store.select(profilePictureById(this.employeeId));
        }
    }
}
